const DefaultSortIcon = ({ height, width, color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 -960 960 960" width={width} fill={color}>
      <path d="M340.16-445.85v-298.23L224.77-628.69 188-665.85 366.15-844l178.16 178.15-36.77 37.16-115.39-115.39v298.23h-51.99ZM593.46-116 415.31-294.15l36.77-37.16 115.38 115.39v-298.23h52v298.23l115.39-115.39 36.76 37.16L593.46-116Z" />
    </svg>
  );
};

export default DefaultSortIcon;
